var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loadingProject)?_c('Loading'):_c('EditProjectForm',{attrs:{"project":_vm.formatProject(_vm.currentProject),"allTeams":_vm.allTeams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }